import { makeActionCreator } from '../../../../utilities'
import { AirwayConstants } from './airway.constants'

export const setVerificationMethod = makeActionCreator(
  AirwayConstants.SET_VERIFICATION_METHODS,
  'prAirwayVerificationAssess'
)
export const setLengthBasedTapeMeasure = makeActionCreator(AirwayConstants.SET_LENGTH_BASED_TAPE_MEASURE, 'broselow')
export const setLengthBasedTapeMeasurePNNV = makeActionCreator(
  AirwayConstants.SET_LENGTH_BASED_TAPE_MEASURE_PNNV,
  'broselowPNNV'
)
export const setStatus = makeActionCreator(AirwayConstants.SET_STATUS, 'airStatus')
export const setSecuredVia = makeActionCreator(AirwayConstants.SET_SECURED_VIA, 'airType')
export const setTubeSize = makeActionCreator(AirwayConstants.SET_TUBE_SIZE, 'airEttSize')
export const setTubeSizeUnit = makeActionCreator(AirwayConstants.SET_TUBE_SIZE_UNIT, 'airEttSizeUnit')
export const setTubeSizeUnitClient = makeActionCreator(AirwayConstants.SET_TUBE_SIZE_UNIT_CLIENT, '__airEttSizeUnit')
export const setDepth = makeActionCreator(AirwayConstants.SET_DEPTH, 'airEttLips')
export const setComments = makeActionCreator(AirwayConstants.SET_INITIAL_ASSESSMENT_AIRWAY_COMMENTS, 'airComments')
export const setPerformedBy = makeActionCreator(AirwayConstants.SET_PERFORMED_BY, 'airBy')
export const setOutcome = makeActionCreator(AirwayConstants.SET_OUTCOME, 'airOutcome')
export const setExam = makeActionCreator(AirwayConstants.SET_EXAM, 'prAirwayAssess')
export const saveInitialAssessmentAirway = makeActionCreator(AirwayConstants.SAVE_INITIAL_ASSESSMENT_AIRWAY)
export const saveInitialAssessmentAirwayNabc = makeActionCreator(
  AirwayConstants.SAVE_INITIAL_ASSESSMENT_AIRWAY_NABC,
  'prNabc'
)
export const resetInitialAssessmentAirway = makeActionCreator(AirwayConstants.RESET_INITIAL_ASSESSMENT_AIRWAY)
